import { Chart } from "react-google-charts";

export const options = {
    title: "Eventos por Año",
    // chartArea: { width: "50%" },
    hAxis: {
        title: "Total",
        minValue: 0,
    },
    vAxis: {
        title: "Año",
    },
};

const EventsChart = ({ data }) => {
    return(
        <Chart
            chartType="BarChart"
            options={options}
            width="100%"
            height="400px"
            data={data}
        />
    )
}

export default EventsChart;